<template>
  <div class="quickconnect-container">
    <div class="quick-connects-head">
      <span class="quick-connects-title"> Quick Connects </span>
    </div>

    <div class="quick-connects-body">
      <div v-if="!quickconnects.length" style="display: flex; justify-content: center;">
        <h6 >No Agents in Quick Connects</h6>


      </div>
      <b-row :key="index" v-for="(contact, index) in quickconnects">
        <b-col cols="9">
          <p class="quick-connects-name">{{ contact.name }}</p>
        </b-col>
        <b-col cols="3" class="text-left">
          <font-awesome-icon
            class="contact-side-icon"
            style="color:#636e72;cursor:pointer"
            @click="OnQuickConnectCall(contact)"
            icon="phone-alt"
            size="sm"
          />
        </b-col>
      </b-row>
    </div>
    <b-button
     
      size="sm"
      @click="changeCallSubNav('call')"
      variant="outline-secondary"
      id="tooltip-target-back"
    >
      <font-awesome-icon icon="chevron-left" size="sm" /> Back
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import { onAddConference } from "./../../lib/CallActions";
import { checkThirdPartyStatus } from "../../lib/ContactRefresh";
import store from "../../store";

export default {
  name: "QuickConnects",
  data() {
    return {};
  },
  created() {},
  methods: {
    async OnQuickConnectCall(contact) {
      console.log("this is quick connect contacts name",contact.name);
      store.dispatch('call/updateThirdPartyCallerName',contact.name);
      await onAddConference("quickconnect", contact);
      let confStatus = await checkThirdPartyStatus();
      if (confStatus == "success") {
        this.$store.dispatch("call/setCallType", "conference");
        this.$store.dispatch("actions/callSubNavigation", "call");
      } else {
        let postData = {};
        postData.action = "SHOW_NOTIFICATION";
        postData.type = "ERROR";
        parent.postMessage("*", postData);
      }
    },
    changeCallSubNav(page) {
      this.$store.dispatch("actions/callSubNavigation", page);
    },
  },
  computed: {
    ...mapGetters(["quickconnects", "callSubNav"]),
  },
};
</script>

<style scoped>
.contact-side-icon {
  margin-right: 5px;
  margin-left: 5px;
}
.contact-side-icon:hover {
  color: #2c5cc5 !important;
}

.quick-connects-name {
  text-align: left !important;
  font-size: 13px;
  margin: 5px;
}

.quick-connects-body {
  margin-top: 10px;
  height: 420px;
  overflow: auto;
  /* Hide scrollbar - Chrome, Edge, Safari */
  scrollbar-width: none;       /* Firefox */
  -ms-overflow-style: none;    /* IE 10+ */
}

.quick-connects-body::-webkit-scrollbar {
  display: none;               /* Chrome, Safari */
}

.quick-connects-head {
  text-align: left;
}

.quick-connects-title {
  font-weight: bold;
  font-size: 20px;
}
</style>
